import React from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from '../Components/Individuals/HeroSection';
import KeyBenefitsSection from '../Components/Individuals/KeyBenefitsSection';
import HowItWorksSection from '../Components/common/HowItWorksSection';
import AchievementsSection from '../Components/common/AchievementsSection';
import CallToActionSection from '../Components/common/CallToActionSection';
import FAQSection from '../Components/common/FAQSection';
import { individualSteps } from '../Components/Individuals/data/howItWorksData';
import { individualAchievements } from '../Components/Individuals/data/achievementsData';
import { individualCTA } from '../Components/Individuals/data/callToActionData';
import { individualFAQs } from '../Components/Individuals/data/faqData';
import NavBar from '../Components/NavBar';

const Individuals = () => {
  return (
    <>
      <Helmet>
        <title>Launch Your AI Quest with Lunor.Quest | Empower Your Ideas</title>
        <meta 
          name="description" 
          content="Host your AI challenge on Lunor.Quest and bring your ideas to life. Collaborate with global experts to crowdsource solutions at any step of the AI pipeline. Start your quest today!"
        />
      </Helmet>
      <div className="relative font-lexend">
        <NavBar />
        <HeroSection />
        <KeyBenefitsSection />
        <HowItWorksSection steps={individualSteps} />
        <AchievementsSection achievements={individualAchievements} />
        <CallToActionSection {...individualCTA} />
        <FAQSection faqs={individualFAQs} />
        {/* Add other sections as needed */}
      </div>
    </>
  );
};

export default Individuals; 